import React, { useEffect, useState } from 'react';
import { Table } from 'react-bootstrap';


export const FuelTable = ({ fuelTypes, fuelTypeInfo }) => {

  const columns = ['name', 'short name', 'pathway order', 'pathway group', 'pathway fuel type',
    'pathway feedstock type', 'pathway feedstock source', 'pathway conversion process',
    'pathway conversion energy used', 'pathway fuel process code', 'wtt production efficiency'];

  const [data, setData] = useState()

  useEffect(() => {
    let fuelData = fuelTypes.map(ft => {
      let fti = fuelTypeInfo[ft.name]
      const { color_name, ...fti_filtered } = fti
      return fti_filtered
    })
    setData(fuelData)
  }, [fuelTypes, fuelTypeInfo])

  if (!!!data) return <div />
  return (

    <Table striped bordered hover>
      <thead>
        <tr>
          {columns.map((c, idx) => <th scope="col" key={`colheader_${idx}`}>{c}</th>)}
        </tr>
      </thead>
      <tbody>
      {data.map((row, idxr) => (
          <tr key={`${row.name}-${idxr}`} style={idxr % 2 === 1 ? { backgroundColor: "rgba(128, 128, 128, 0.05)" } : { backgroundColor: "white" }}>
            {Object.values(row).map((value, idx) => (
              <td key={`${value}-${idxr}-${idx}`}>{value}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </Table>
    // <table className="table">
    //   <thead>
    //     <tr>
    //       {columns.map((c, idx) => <th scope="col" key={`colheader_${idx}`}>{c}</th>)}
    //     </tr>
    //   </thead>
    //   <tbody>

    //     {data.map((row, idxr) => (
    //       <tr key={`${row.name}-${idxr}`} style={idxr % 2 === 1 ? { backgroundColor: "rgba(128, 128, 128, 0.05)" } : { backgroundColor: "white" }}>
    //         {Object.values(row).map((value, idx) => (
    //           <td key={`${value}-${idxr}-${idx}`}>{value}</td>
    //         ))}
    //       </tr>
    //     ))}
    //     {/* Additional rows go here */}
    //   </tbody>
    // </table>
  );
};
